<template>

    <fragment>

        <draggable v-if="listToAddTo && listToAddTo.length && editable" class="current moveable" :list="listToAddTo" tag="ul" @start="drag=true" @end="drag=false" @change="onChange">
            <li :class="{ visible : editable }" v-for="(item, index) in listToAddTo" :key="`${index}-${name}`" :option-id="item.id ? item.id : ''">
                <div>{{ typeof item === 'object' ? getName(item) : item }}</div>
                <span class="remove"><i v-on:click.prevent="removeFromList($event, item)" class="fas fa-times"></i></span>
            </li>
        </draggable>

        <ul v-if="!editable" class="current">
            <li v-for="(item, index) in listToAddTo" :key="`${index}-${name}`">
                <div>{{ typeof item === 'object' ? getName(item) : item }}</div>
            </li>
        </ul>

        <div v-if="editable && showError" class="confirmation bg-danger">
            Alternativet finns redan i listan...
        </div>

        <input v-if="editable" :placeholder="placeholder" v-model="addValue" v-on:input.prevent="search" type="search" :id="name" class="form-control search-and-add">

        <ul class="search-and-add" v-if="values.length && isSearching && addValue.length">
            <li v-for="value in values" :key="value.id" v-on:click="addToList($event, value[column])">
                {{ value[column] }}
            </li>
        </ul>

        <ul class="search-and-add" v-if="isSearching && addValue.length">
            <li v-on:click="addToList">{{ language.add }} "{{ addValue }}"</li>
        </ul>

    </fragment>

</template>

<script>

import { Fragment } from 'vue-fragment'

import dataStore from '../store'

import axios from 'axios'

import Draggable from 'vuedraggable'

const _ = require('lodash')

export default {

    components: {
        Fragment,
        Draggable
    },

    data() {
        return {
            showModal: false,
            results : false,
            values : [],
            addValue : '',
            dataStore,
            isSearching : false,
            debounce : null,
            showError : false
        }
    },

    inject: [ 'language', 'superadmin' ],

    computed: {

        editable: function() {
            return this.superadmin ? true : ( this.dataStore.project.allowToEdit && this.dataStore.isLoaded )
        },

        csrftoken: function() {
            return document.querySelector('meta[name="csrf-token"]').content;
        },

        fixedModel: function() {
            return this.model.charAt(this.model.length - 1) !== 'y' ? `${this.model}s` : `${this.model.slice(0, -1)}ies`
        },

        listToAddTo: {
            get() {
                return this.dataStore.project[this.fixedModel]
            },

            set(newName) {
                return newName
            }
        },

        singleStringValue: function() {
            return this.dataStore.project[`${this.model}`]
        }

    },

    props: {
        model: String,
        placeholder : String,
        column : String,
        name : String,
        type : String
    },

    methods : {

        search(event) {

            clearTimeout(this.debounce)

            this.debounce = setTimeout(() => {

                if(this.addValue !== '') {

                    this.isSearching = true;

                    axios.get(`/api/get-alternatives/${this.type}/${this.column}/${this.addValue}`)
                    .then(response => {
                        if(response.data) {
                            this.values = response.data
                        }
                    })

                }

            }, 500)

        },

        addToList: function(event, newValue = null) {
            event.target.disabled = true;

            if(this.addValue === '') return

            let valueToPush = { sort : 0 }

            valueToPush[this.column] = newValue === null ? this.addValue : newValue;

            let optionsArray = [...this.listToAddTo]

            // if not in array - allow to add to list
            // need to be same key as in db to match on the object
            if(!optionsArray.map(item => item[this.column]).includes(valueToPush[this.column])) {
                optionsArray.push(valueToPush);
                optionsArray = [...new Map(optionsArray.map(item => [item[this.column], item])).values()];

                const model = this.model.charAt(this.model.length - 1) !== 'y' ? `${this.model}s` : `${this.model.slice(0, -1)}ies`
                _.set(this.$data, `dataStore.project.${model}`, optionsArray)
            }

            else {
                this.showError = true;

                setTimeout(() => {
                    this.showError = false;
                } , 2000);

            }

            this.addValue = ''
            this.values = [];
            this.isSearching = false;
        },

        removeFromList: function(e, value) {

            e.stopPropagation();

            if(this.editable) {
                let index = this.listToAddTo.indexOf(value);
                this.listToAddTo.splice(index, 1);
            }

        },

        onChange: function(event) {

            let slideItem = this.dataStore.projectItems[this.dataStore.activeIndex];

            const index = event.moved.newIndex
            const item = event.moved.element
            let newSorting = this.listToAddTo.filter(i => i !== item );

            newSorting.splice(index, 0, item)
            newSorting.map((item, index) => item.sort = index + 1 )

            this.listToAddTo = newSorting;

            axios.post(`/api/sort-options`,{
                data : this.listToAddTo,
                project_id : this.dataStore.currentProjectID,
                item_id: slideItem !== undefined ? slideItem.id : null,
                type : this.model,
                headers: {
                    'Content-Type': 'multipart/form-data'
                }}
            )
        },

        getName: function(item) {

            if(item.hasOwnProperty('gender'))  {
                return item.gender
            }
            else if(item.hasOwnProperty('type') && !item.hasOwnProperty('value')) {
                return item.type
            }
            else if(item.hasOwnProperty('name')) {
                return item.name
            }
            else if(item.hasOwnProperty('age')) {
                return item.age
            }
            else {
                return item.value
            }

        }

    }
};

</script>







